import React from 'react';
import { Grid, Container, Box, Divider } from '@material-ui/core';
import { Map, GoogleApiWrapper } from 'google-maps-react';
import HeaderSection from '../../components/reusableComponents/HeaderSection';
import MapContainer from './Map';
const data = [
	{
		title: 'Quick & Easy Bookings',
		desc: 'Booking a taxi for yourself in Hire Click N Book is very easy, just say it is time to put your finger. Your order will be booked in seconds. You don’t even need to read rocket science to do it.',
	},
	{
		title: 'Expert Trip Planners',
		desc: 'Every volunteer we have is famous in this field, who will be your companion in your journey, who will be ready to help you in every way related to travel. You can connect with us anytime by phone, we will be happy to help you.',
	},
	{
		title: 'Easy Tour Customization',
		desc: 'Our team ensures that you are not inconvenienced in any way in your journey. We have trips ready for people of all ages who are prescribed by our experts, but still, we provide you the service under which you can plan your tour yourself.',
	},
	{
		title: 'Quick & Easy Bookings',
		desc: 'Booking a taxi for yourself in Hire Click N Book is very easy, just say it is time to put your finger. Your order will be booked in seconds. You don’t even need to read rocket science to do it.',
	},
	{
		title: 'Anytime Support',
		desc: 'The numbers given on our website are ready to listen to you all the time. Every person can call 24 hours and 7 days at any time. Our expert members and dedicated team feel jovial while helping the customers. You can contact us at any time for the travel bookings and for the proper guidance regarding your destined site. Click N Book is always there to help you and guide you 24/7.',
	},
	{
		title: 'Expert Cab Drivers',
		desc: 'We make regular efforts to make your journey memorable. For this we also ensure that the members working with us have experts in their fields so that the passengers do not face any problem. You will find all our drivers full of information and energy which will help you all the time.',
	},
	{
		title: 'Knowledge-Base Guides',
		desc: 'Whatever you should lose all sense of direction in Himachal disputants, it will give by Hire Click N Book. Our movement specialists will reveal to you the things of Himachal that no one will let you know. Try not to stress over this, regardless of whether your cell phone isn’t supporting you, our specialists and we will bolster you. Our specialists are accessible for you 24 hours. Our specialists can dodge no issue identified with the movement. Our specialists will take care of each issue when necessary. So come and pick the best travel visit specialists in Himachal Pradesh. We manage your joy.',
	},
];

const data2 = [
	{
		i: 'fas fa-lock',
		title: '100% Secure',
		desc: 'Moving your card details to a much more secured place.',
	},
	{
		i: 'fas fa-thumbs-up',
		title: 'Trust pay',
		desc: '100% Payment Protection. Easy Return Policy.',
	},
	{
		i: 'fas fa-bullhorn',
		title: 'Refer & Earn',
		desc: 'Invite a friend to sign up and earn up to Rs 100.',
	},
	{
		i: 'far fa-life-ring',
		title: '24X7 Support',
		desc: "We're here to help. Have a query and need help ?",
	},
];
const ContactusPage = () => {
	return (
		<>
			<HeaderSection id={1} />
			<section style={{ background: '#0c2f55', color: 'white', marginTop: 50 }}>
				<Grid container>
					<Grid item xs={8}>
						<h1>About Us</h1>
					</Grid>
					<Grid item xs={4}></Grid>
				</Grid>
			</section>

			<section style={{ background: '#0c2f55', color: 'white', marginTop: 50 }}>
				<Grid container>
					{data2.map((item) => {
						return (
							<Grid item xs={3}>
								<Box display='flex' alignItems='baseline'>
									<i class={item.i} style={{ height: 50, width: 45 }}></i>
									<Box>
										<h3 style={{ color: '#f8f9fa' }}>{item.title}</h3>
										<p
											style={{
												color: '#f8f9fa',
												fontFamily: '"Poppins", sans-serif',
											}}>
											{item.desc}
										</p>
									</Box>
								</Box>
							</Grid>
						);
					})}
				</Grid>
			</section>
			{/* <MapContainer /> */}
			<Container>
				<Divider style={{ marginTop: 20 }} />
			</Container>
			<section className='footer'>
				<div className='box-container'>
					<div className='box' data-aos='fade-up'>
						<h3>Musafir Bazar</h3>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Company Info
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Company Policy
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Privacy Policy
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Terms & Condition
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Careers
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i>
							About Us
						</a>
					</div>

					<div className='box' data-aos='fade-up'>
						<h3>Products</h3>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Flight Booking
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Bus Booking
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Hotel Booking
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Holiday Booking
						</a>
						<a href='#'>
							<i className='fas fa-chevron-right'></i> Car Booking
						</a>
					</div>

					<div className='box' data-aos='fade-up'>
						<h3>Contact Info</h3>
						<a href='#'>
							<i className='fas fa-phone'></i> +91 887-777-3388
						</a>
						<a href='#'>
							<i className='fas fa-envelope'></i>sales@musafirbazar.com
						</a>
						<a href='#'>
							<i className='fas fa-map-marker-alt'></i>1st Floor,New Tech Grand,
							Bank More, Dhanbad-826001
						</a>
					</div>

					<div className='box' data-aos='fade-up'>
						<h3>Follow Us</h3>
						<a href='https://www.facebook.com/musafirbazaar' target='_blank'>
							<i className='fab fa-facebook-f'></i> facebook
						</a>
						<a href='https://twitter.com/musafirbazar' target='_blank'>
							<i className='fab fa-twitter'></i> twitter
						</a>
						<a href='https://www.instagram.com/musafirbazar/' target='_blank'>
							<i className='fab fa-instagram'></i> instagram
						</a>
						<a
							href='https://www.linkedin.com/company/musafirbazar'
							target='_blank'>
							<i className='fab fa-linkedin'></i> linkedin
						</a>
						<a href='#'>
							<i className='fab fa-pinterest'></i> pinterest
						</a>
					</div>
				</div>

				<div className='credit' style={{ fontSize: 14 }}>
					Copyright ©2022, All Rights Reserved. Powered by Arya Aviation Pvt.
					Ltd.
				</div>
			</section>
		</>
	);
};

export default ContactusPage;
